export default "__VITE_ASSET__BXyA93V8__"